import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ImpersonateIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5 4a1 1 0 0 0-1 1v2a1 1 0 0 1-2 0V5a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H5Zm11-1a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v2a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1h-2a1 1 0 0 1-1-1Zm5 13a1 1 0 0 1 1 1v2a3 3 0 0 1-3 3h-2a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1ZM3 16a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1Zm7-4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M7.26 7.449a8.5 8.5 0 0 1 12.628 3.891 2 2 0 0 1-.018 1.368 8.5 8.5 0 0 1-15.758-.048 2 2 0 0 1 .018-1.368A8.5 8.5 0 0 1 7.26 7.45Zm4.74.555A6.5 6.5 0 0 0 6.002 12a6.5 6.5 0 0 0 11.996 0A6.5 6.5 0 0 0 12 8.004Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ImpersonateIcon;
